import { render, staticRenderFns } from "./next-step.vue?vue&type=template&id=fec07e7c&scoped=true&"
import script from "./next-step.vue?vue&type=script&lang=js&"
export * from "./next-step.vue?vue&type=script&lang=js&"
import style0 from "./next-step.vue?vue&type=style&index=0&id=fec07e7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec07e7c",
  null
  
)

export default component.exports